export const baseUrl = '/api';
